/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/control-has-associated-label */
import profileIcon from 'assets/images/profileIcon.svg';
import CN from 'classnames';
import useGetNotificationCount from 'framework/api/methods/profile/useGetNotificationCount';
import { FC, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import MenuDrawer from './MenuDrawer';

export interface HeaderProps {
  [x: string]: any;
  userDetails?: any;
  firstRoute?: any;
  menuItemList?: any;
}

export const Header: FC<HeaderProps> = ({
  className,
  userDetails = undefined,
  firstRoute = undefined,
  menuItemList = undefined,
  ...restProps
}: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const HeaderClasses = CN(
    'main-layout__header z-10 h-[70px] pl-2 pr-1 py-[12px] flex justify-between items-center w-full bg-white',
    className,
  );

  const [isOpenProfileDropdown, setIsOpenProfileDropdown] = useState(false);
  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);

  // Ref for the dropdown menu container
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpenProfileDropdown(!isOpenProfileDropdown);
  };

  const handleProfilePage = () => {
    navigate('/profile');
  };

  const handleSignOut = () => {
    localStorage.clear();
    navigate('/auth/login', { replace: true });
  };

  const [header, setHeader] = useState('');

  // Hardcoded mapping of routes to page headers
  const pageHeaderMapping: Record<string, string> = {
    '/': 'Dashboard',
    '/videos': 'Videos',
    '/content-creators': 'Content Creators',
    '/content-creators/:id': 'Content Creators',
    '/enterprises': 'Enterprises',
    '/enterprises/:id': 'Enterprises',
    '/enterprises/create': 'Enterprises',
    '/enterprises/update/:id': 'Enterprises',
    '/allocated-videos': 'Allocated Videos',
    '/profile': 'Profile',
    '/categories': 'Categories',
  };

  useEffect(() => {
    const path = location.pathname;

    const matchedHeader =
      Object.entries(pageHeaderMapping).find(([pattern]) => {
        // Convert route pattern to RegExp (e.g., "/videos/:id" -> /^\/videos\/[^/]+$/)
        const regexPattern = new RegExp(`^${pattern.replace(/:[^/]+/g, '[^/]+')}$`);
        return regexPattern.test(path);
      })?.[1] ?? '';

    setHeader(matchedHeader);
  }, [location.pathname]);

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpenProfileDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [notificationCount, setNotificationCount] = useState(0);
  const onSuccessNotifications = (data: any) => {
    setNotificationCount(data?.data?.total_pending_videos);
  };

  const onErrorNotifications = ({ response: { data: errData }, response }: any) => {
    if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
      setTimeout(() => {
        navigate('/auth/login');
        localStorage.clear();
      }, 2000);
    } else {
      // notify(errData?.message || 'Something went wrong.', 'error');
    }
  };

  /** Get all cards API */
  const { refetch: getNotifications, data } = useGetNotificationCount(
    onSuccessNotifications,
    onErrorNotifications,
  );
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (token) {
      getNotifications();
    }
  }, [location?.pathname, token]);

  return (
    <header className={HeaderClasses} {...restProps}>
      <div className="header__left flex items-center py-[6px]">
        <i
          className="ri-menu-line text-lg pr-3 text-neutral-700 pl-2"
          onClick={() => {
            setIsMenuDrawerOpen(true);
          }}
        />
        <span className="text-3xl font-semibold px-2 text-[#C40D42]">{header}</span>
      </div>

      <div className="header__left flex items-center">
        <div className="h-14 flex items-center justify-start rounded ml-6 pr-5">
          <div
            className="relative mr-8 md:flex hidden"
            onClick={() => {
              if (notificationCount > 0) {
                navigate('/videos?status=pending');
              }
            }}
          >
            <i className="ri-notification-2-line text-[#C40D42] text-[24px] leading-none cursor-pointer" />
            {notificationCount > 0 && (
              <div className="absolute top-[-4px] right-0 w-[14px] h-[14px] rounded-full bg-[#C40D42] text-white cursor-pointer flex justify-center items-center text-[6px]">
                {notificationCount > 9 ? `9+` : notificationCount}
              </div>
            )}
          </div>
          <img
            src={profileIcon}
            alt="profile-icon"
            className="md:w-[40px] md:h-[40px] w-[35px] h-[35px]"
          />
          <div className="flex pl-1 md:pl-5">
            <div className="flex flex-col text-sm font-medium text-[#151D48]">
              Super Admin
              <div className="text-xs font-normal text-[#737791] pt-1">Admin</div>
            </div>

            <div className="relative pl-2 pt-2" ref={dropdownRef}>
              <i
                className="ri-arrow-down-s-line text-xl cursor-pointer leading-none"
                onClick={toggleDropdown}
              />

              {isOpenProfileDropdown && (
                <div className="absolute top-[14px] right-0 mt-3 w-[100px] bg-white shadow-lg rounded-md border border-gray-300">
                  {/* <button
                      onClick={handleProfilePage}
                      className="w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-t-lg"
                    >
                      My Profile
                    </button> */}
                  <button
                    onClick={handleSignOut}
                    className="w-full text-left px-3 py-2 text-red-700 hover:bg-gray-100 rounded-b-lg"
                  >
                    Log Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <MenuDrawer
        isOpen={isMenuDrawerOpen}
        onClose={() => setIsMenuDrawerOpen(false)}
        menuItemList={menuItemList}
        firstRoute={firstRoute}
        userDetails={userDetails}
        setIsMenuDrawerOpen={setIsMenuDrawerOpen}
      />
    </header>
  );
};

export default Header;
